<template>
    <div class="ref-user-link">
        <RefUserButton
            text="Баллы за друзей"
            @click="toggleDialog"
            @onRefLink="onRefLink"
            @onFriendsCount="onFriendsCount"
            @onScoresCount="onScoresCount"
        />

        <Dialog
            :is-popup.sync="showDialog"
            :scrollable="true"
            :overlayOffset="false"
            :padding="false"
            @close="showDialog = false"
        >
            <RefUserModal :ref-link="refLink" :friends-count="friendsCount" :scores-count="scoresCount" />
        </Dialog>
    </div>
</template>

<script>
import Dialog from '@/components/UI/Dialog';
import RefUserButton from './RefUserButton.vue';
import RefUserModal from './RefUserModal.vue';
import { lockScroll, unlockScroll } from '@/tools/scrollLock';
export default {
    name: 'RefUser',
    components: {
        Dialog,
        RefUserButton,
        RefUserModal,
    },

    data: () => ({
        showDialog: false,
        refLink: '',
        friendsCount: 0,
        scoresCount: 0,
    }),

    watch: {
        showDialog(val) {
            if (val) {
                lockScroll();
            } else {
                unlockScroll();
            }
        },
    },

    methods: {
        toggleDialog() {
            this.showDialog = true;
        },

        onRefLink(refLink) {
            this.refLink = refLink;
        },

        onFriendsCount(friendsCount) {
            this.friendsCount = friendsCount;
        },

        onScoresCount(scoresCount) {
            this.scoresCount = scoresCount;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';

.ref-user-link {
    @include on-mobile {
        :deep(.dialog-wrapper) {
            background: none;
        }

        :deep(.dialog) {
            height: 100%;
            max-height: 100%;
        }
    }

    @include on-desktop {
        :deep(.dialog) {
            padding: 0;
            max-height: 100% !important;
        }
    }
}
</style>
